import { ReactNode } from 'react';
import {
  mdiAtom,
  mdiChartBarStacked,
  mdiChartGantt,
  mdiClockAlertOutline,
  mdiClockRemoveOutline,
  mdiCloudAlert,
  mdiCloudCheckVariant,
  mdiCodeBracesBox,
  mdiContentDuplicate,
  mdiContentSaveAll,
  mdiContentSaveMove,
  mdiFormatListText,
  mdiFruitCherries,
  mdiHandCoin,
  mdiMovieOpen,
  mdiPlayBox,
  mdiPlayBoxMultiple,
  mdiPlaylistStar,
  mdiSortAscending,
  mdiSortDescending,
  mdiTelevisionClassic,
  mdiTextBoxSearchOutline,
  mdiWeatherDust,
} from '@mdi/js';
import {
  AccessTime,
  AccountCircle,
  AcUnit,
  Add,
  AddPhotoAlternate,
  AdminPanelSettings,
  Apps,
  ArrowBack,
  ArrowDropDown,
  ArrowForward,
  Article,
  AutoFixHigh,
  Book,
  Build,
  CallSplit,
  Campaign,
  Cancel,
  Category,
  Check,
  CheckCircle,
  Close,
  CloudOutlined,
  CloudSync,
  CloudUpload,
  Collections,
  CompareArrows,
  Construction,
  ContentCopy,
  Crop,
  CropDin,
  CropFree,
  CropLandscape,
  CropPortrait,
  DarkMode,
  DashboardCustomize,
  DataObject,
  Delete,
  Description,
  Devices,
  DoneAll,
  Download,
  DragIndicator,
  Dvr,
  Edit,
  Error,
  ExpandLess,
  ExpandMore,
  FilterAlt,
  FirstPage,
  Flag,
  Folder,
  Handshake,
  Help,
  Home,
  Image,
  Info,
  Insights,
  IosShare,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Landscape,
  LastPage,
  LibraryAdd,
  LightMode,
  Link,
  List,
  LiveTv,
  LocalOffer,
  Menu,
  MergeType,
  MoreHoriz,
  MoreVert,
  NearbyError,
  Notes,
  OndemandVideo,
  OpenInNew,
  Pool,
  Preview,
  PriorityHigh,
  Public,
  Remove,
  Reorder,
  Repeat,
  RepeatOne,
  Replay,
  Rule,
  Save,
  Schema,
  Search,
  SearchOff,
  Settings,
  Shop,
  Smartphone,
  Star,
  StarOutline,
  Stars,
  Sync,
  Timeline,
  Translate,
  Tune,
  Tv,
  VideoLibrary,
  VideoSettings,
  Visibility,
  VisibilityOff,
  Warning,
  Widgets,
} from '@mui/icons-material';
export const MuiIconMap = {
  add: Add,
  addImage: AddPhotoAlternate,
  admin: AdminPanelSettings,
  arrowBack: ArrowBack,
  arrowDropDown: ArrowDropDown,
  arrowForward: ArrowForward,
  article: Article,
  bookmark: Book,
  build: Build,
  cancel: Cancel,
  category: Category,
  check: Check,
  checkCircle: CheckCircle,
  chevronDown: KeyboardArrowDown,
  chevronLeft: KeyboardArrowLeft,
  chevronRight: KeyboardArrowRight,
  clock: AccessTime,
  close: Close,
  cloud: CloudOutlined,
  cloudUpload: CloudUpload,
  compareArrows: CompareArrows,
  construction: Construction,
  contentPackage: DashboardCustomize,
  copy: ContentCopy,
  crop: Crop,
  cropFree: CropFree,
  components: Widgets,
  cloudSync: CloudSync,
  cropLandscape: CropLandscape,
  cropPortrait: CropPortrait,
  cropSquare: CropDin,
  darkMode: DarkMode,
  dataObject: DataObject,
  delete: Delete,
  description: Description,
  devices: Devices,
  doubleCheck: DoneAll,
  download: Download,
  dragIndicator: DragIndicator,
  edit: Edit,
  error: Error,
  exclamationMark: PriorityHigh,
  expandLess: ExpandLess,
  expandMore: ExpandMore,
  export: IosShare,
  filterAlt: FilterAlt,
  firstPage: FirstPage,
  flag: Flag,
  folder: Folder,
  grid: Apps,
  help: Help,
  home: Home,
  image: Image,
  images: Collections,
  info: Info,
  insights: Insights,
  landscape: Landscape,
  lastPage: LastPage,
  libraryAdd: LibraryAdd,
  lightMode: LightMode,
  link: Link,
  list: Reorder,
  liveTv: LiveTv,
  magic: AutoFixHigh,
  menu: Menu,
  merge: MergeType,
  moreHoriz: MoreHoriz,
  moreVert: MoreVert,
  move: CallSplit,
  nearbyError: NearbyError,
  notes: Notes,
  onDemandVideo: OndemandVideo,
  openInNew: OpenInNew,
  overview: Dvr,
  partner: Handshake,
  playbackUrls: VideoSettings,
  preview: Preview,
  promo: Campaign,
  public: Public,
  remove: Remove,
  repeat: Repeat,
  repeatOne: RepeatOne,
  replay: Replay,
  rule: Rule,
  save: Save,
  schema: Schema,
  search: Search,
  searchOff: SearchOff,
  settings: Settings,
  smartphone: Smartphone,
  snowflake: AcUnit,
  star: Star,
  starCircle: Stars,
  starOutline: StarOutline,
  subscriber: AccountCircle,
  swimlane: Pool,
  sync: Sync,
  tag: LocalOffer,
  timeline: Timeline,
  titleProduct: Shop,
  translate: Translate,
  tune: Tune,
  tv: Tv,
  unorderedList: List,
  videoLibrary: VideoLibrary,
  visibility: Visibility,
  visibilityOff: VisibilityOff,
  warning: Warning,
} as const;

export const MDIconMap = {
  atom: mdiAtom,
  chart: mdiChartBarStacked,
  cherry: mdiFruitCherries,
  clockError: mdiClockRemoveOutline,
  clockWarning: mdiClockAlertOutline,
  cloudAlert: mdiCloudAlert,
  cloudCheck: mdiCloudCheckVariant,
  codeBracesBox: mdiCodeBracesBox,
  duplicate: mdiContentDuplicate,
  dust: mdiWeatherDust,
  epg: mdiChartGantt,
  lookup: mdiTextBoxSearchOutline,
  movie: mdiMovieOpen,
  pageSection: mdiFormatListText,
  playBox: mdiPlayBox,
  playBoxMultiple: mdiPlayBoxMultiple,
  provider: mdiHandCoin,
  rootMenu: mdiPlaylistStar,
  saveAndClose: mdiContentSaveMove,
  saveCopy: mdiContentSaveAll,
  sortAscending: mdiSortAscending,
  sortDescending: mdiSortDescending,
  televisionClassic: mdiTelevisionClassic,
};

export const IconMap = {
  ...MuiIconMap,
  ...MDIconMap,
};

export type IconOption = keyof typeof IconMap;

export const IconOptions = Object.keys(IconMap) as IconOption[];

export const isIconOption = (str: ReactNode | string): str is IconOption =>
  typeof str === 'string' && IconOptions.includes(str as IconOption);
